module.exports = __webpack_public_path__ + "static/media/info-keypoint1.c50d7344.png";